module.exports = __webpack_public_path__ + "static/media/crypto_thugs.df171826.png";